var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k5-form container"},[_c('error'),(_vm.isOnEventSelection)?_c('event-selection'):_vm._e(),(_vm.isOnStepWrapper)?_c('step-wrapper'):_vm._e(),(_vm.isOnSuccessStep)?_c('success-page'):_vm._e(),_c('error')],1)}
var staticRenderFns = []

export { render, staticRenderFns }